import PropTypes from 'prop-types';
import React from "react";
import { connect } from 'react-redux';
import ObjectSearchInput from 'components/functional/inputs/ObjectSearchInput'

class OfficeSearchInput extends React.Component {

    state = {
        filter: null,
        showResults: false,
        selected: {},
        dataToShow: []
    }

    onSelect = (selected) => {

        this.setState({selected, filter: '', showResults: false})
        this.props.onSelect(selected)

    }

    onChange = (value) => {

        let data = this.props.offices || [];
        data = [...data]

        if(value && value !== null) {

            let filter = value.toLowerCase()
            this.setState({dataToShow: data.filter(c =>  c.name.toLowerCase().includes(filter))})

        } else {

            this.setState({dataToShow: data })

        }

    }

    componentWillReceiveProps = (nextProps) => {
        if(this.props.value && !nextProps.value) {
            this.setState({selected: {}})
        } else if(this.props.value && nextProps.value && this.props.value._id !== nextProps.value._id) {

            this.setState({ selected: nextProps.value })
        }
    }

    componentDidMount = () => {
        const { offices, value } = this.props
        this.setState({ dataToShow: offices, selected: value ? value : {} })
    }

    render() {

        const { dataToShow, selected } = this.state
        const { titleFormatter, hideTitle } = this.props

        return (
            <ObjectSearchInput 
                hideTitle={hideTitle}
                data={dataToShow}
                onChange={this.onChange}
                onSelect={this.onSelect}
                placeholderFormatter={selected ? selected.name : 'Type To Search'}
                titleFormatter={
                    titleFormatter ? titleFormatter(selected) : 
                        selected ? <span>Selected Office: <b className="text-success">{selected.name}</b></span> : 
                        'Select Office'
                }
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        offices: state.offices.offices,
    };
};

OfficeSearchInput.propTypes = {
    onSelect        : PropTypes.func.isRequired,
    titleFormatter  : PropTypes.func,
    wrapperStyles   : PropTypes.object,
    formGroupStyles : PropTypes.object,
    value           : PropTypes.object,
    hideTitle       : PropTypes.bool,
    title           : PropTypes.string,
}

export default connect(mapStateToProps, '')(OfficeSearchInput);
